// Firebase configuration for Brookmar frontend
// Replace these values with the actual Firebase config from Firebase Console

const firebaseConfig = {
  apiKey: "AIzaSyBaZ8E20IIjOtls8OGEIMOEXpMazP6MxdQ",
  authDomain: "email-insight-test.firebaseapp.com",
  projectId: "email-insight-test",
  storageBucket: "email-insight-test.firebasestorage.app",
  messagingSenderId: "397127935775",
  appId: "1:397127935775:web:22d039bc9bb4362da0722a"
};

export default firebaseConfig;
